import { createRoot } from 'react-dom/client'
import { CommandPalette } from '../components/ui/CommandPalette'

// Mounted into #app-search, which lives inside the data-turbo-permanent header:
// Turbo carries the same node into every new body, so the React root stays
// attached to something still in the document. Mounting per page would tear the
// palette down mid-navigation and lose the ⌘K listener with it.
//
// **Which is why this tracks the node and not a boolean.** The admin area wears
// a header of its own with no #app-search in it (see shared/_admin_header), so
// there are now two ways the container can be absent or replaced: land on
// /admin first and it never exists, then navigate into the app and a *fresh*
// one arrives that nothing has mounted into. A `mounted = true` flag called
// once at boot got both wrong — the palette was dead for the rest of any
// session that began in the admin panel, ⌘K included. Found by starting there
// and pressing it (2026-09-02).
let attached: HTMLElement | null = null

export function initAppSearch() {
  mount()

  // Every navigation, because the container can arrive on one — the same
  // listener appNav uses, for the same reason. `mount` is a no-op on the
  // ordinary navigation, where the permanent node is carried across unchanged.
  document.addEventListener('turbo:load', mount)
}

function mount() {
  const container = document.getElementById('app-search')
  if (!container || container === attached) return

  attached = container
  createRoot(container).render(<CommandPalette />)
}
